import React, { Component } from 'react';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { object, func } from 'prop-types';
import { startAddStream, startSetStreamOffer, resetStreamOffer } from '@actions/streams';
import { setJustRegisteredHasStream } from '@actions/webmaster';

import WithAlert from '@hoc/WithAlert';

import { CreateFlowPageView } from '../index';

class CreateFlowPage extends Component {
  static propTypes = {
    startAddStream: func.isRequired,
    offer: object,
  };

  static defaultProps = {
    startAddStream() {},
  };

  state = {
    loading: false,
  };

  componentDidMount() {
    this.props.resetStreamOffer();
  }

  getOfferId = () => {
    const offerId = parseInt(parse(this.props.location.search).offer, 10);
    return !isNaN(offerId) ? offerId : this.getReduxStreamOffer();
  };

  getReduxStreamOffer = () => {
    const { offer } = this.props;
    return offer && offer.id ? offer.id : 0;
  };

  getLandingId = () => {
    const landingId = parseInt(parse(this.props.location.search).landing, 10);
    return !isNaN(landingId) ? landingId : null;
  };

  getPreLandingId = () => {
    const preLandingId = parseInt(parse(this.props.location.search).prelanding, 10);
    return !isNaN(preLandingId) ? preLandingId : null;
  };

  handleSubmit = (stream) => {
    this.setState(() => ({ loading: true }));

    this.props
      .startAddStream(stream)
      .then(({ stream }) => {
        this.setState(() => ({ loading: false }));

        if (stream && stream.id) {
          if (this.props.justRegistered.is && !this.props.justRegistered.hasStream) {
            this.props.setJustRegisteredHasStream();
          }
          this.props.history.push(`/tools/flows/${stream.id}?created=1`);
        }
      })
      .catch(({ response }) => {
        if (response && response.data) {
          const { message: error } = response.data.error;

          this.props.showAlert({
            alertType: 'danger',
            message: error.message,
          });
        }

        this.setState(() => ({ loading: false }));
      });
  };

  render() {
    const selectedOffer = this.getOfferId();
    const selectedLanding = this.getLandingId();
    const selectedPreLanding = this.getPreLandingId();

    const data = { ...this.state, ...this.props };

    return (
      <CreateFlowPageView
        data={data}
        selectedOffe={selectedOffer}
        selectedLanding={selectedLanding}
        selectedPreLanding={selectedPreLanding}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  offer: state.streams.offer,
  justRegistered: state.webmaster.profile.justRegistered,
});

const mapDispatchToProps = (dispatch) => ({
  startAddStream: (stream) => dispatch(startAddStream(stream)),
  resetStreamOffer: () => dispatch(resetStreamOffer()),
  startSetStreamOffer: (offerId) => dispatch(startSetStreamOffer(offerId)),
  setJustRegisteredHasStream: () => dispatch(setJustRegisteredHasStream()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WithAlert(CreateFlowPage));
